import { Component } from '@angular/core';
import { HeaderComponent } from '../../layout/header/header.component';
import { NavbarComponent } from '../../layout/navbar/navbar.component';
import { SidebarComponent } from '../../layout/sidebar/sidebar.component';
import { RoutelinksService } from '../../services/core/routelinks.service';
import { SharedService } from '../../services/shared.service';

@Component({
  selector: 'app-administration',
  standalone: true,
  imports: [HeaderComponent, NavbarComponent, SidebarComponent],
  templateUrl: './administration.component.html',
  styleUrl: './administration.component.css'
})
export class AdministrationComponent {
  
  links: any[] = []; // Lista de links para el sidebar
  inputValue: string = 'Prueba'; // Valor del input



  constructor(private routelinks: RoutelinksService,
    private sharedService: SharedService
  ) { }

  ngOnInit(): void {
    this.links = this.routelinks.linksAdministration;
  }



}
